import React, { useCallback, useEffect, useState } from "react"
import { Table } from 'rsuite'
import { useDispatch, useStore } from "react-redux"
import { Link } from "react-router-dom/cjs/react-router-dom"
import moment from "moment"
import { getChildSuppliersWithMasterId } from "../../../../redux/actions/vendor"
import { toast } from "../../../CommonComponents/ToastComponent/toast"
import LoaderComponent from "../../../CommonComponents/LoaderComponent"
const { Column, HeaderCell, Cell, Pagination } = Table

export const TableCell = ({ rowData, dataKey, type = 'string', ...props }) => {
  if (type === 'date') {
    const formattedDate = rowData?.[dataKey] ? moment(rowData?.[dataKey])?.format('MM/DD/YYYY') : '';
    rowData[dataKey] = formattedDate
  } else if (type === 'int') {
    rowData[dataKey] = rowData?.[dataKey] || 0
  } else {
    rowData[dataKey] = rowData?.[dataKey] || ''
  }

  return (
    <Cell {...props} className="table-link" title={rowData?.[dataKey]}>
      <p>
        {rowData[dataKey]}
      </p>
    </Cell>
  )
}

const SupplierHistoricalPayments = ({ masterId = null }) => {
  const store = useStore().getState()
  const dispatch = useDispatch()
  const [isLoading, setIsLoading] = useState(false)
  const [historicalPayments, setHistoricalPayments] = useState([])
  const [limit, setLimit] = useState(10)
  const [page, setPage] = useState(1)

  const {
    vendor: {
      masterSupplierDetails
    }
  } = store

  const columns = [
    {
      name: 'vendor',
      label: 'Supplier Name',
      type: 'string'
    },
    {
      name: 'companyId',
      label: 'Company Id',
      type: 'string'
    },
    {
      name: 'paymentType',
      label: 'Payment Method',
      type: 'string'
    },
    {
      name: 'remitType',
      label: 'Remittance Type',
      type: 'string'
    },
    {
      name: 'remitValue',
      label: 'Remittance Value',
      type: 'string'
    },
    {
      name: 'countSingle',
      label: 'Single Use Payments',
      type: 'int'
    },
    {
      name: 'countMulti',
      label: 'Multi Use Payments',
      type: 'int'
    },
    {
      name: 'countReloadable',
      label: 'Reloadable Payments',
      type: 'int'
    },
    {
      name: 'countStatic',
      label: 'Static Payments',
      type: 'int'
    },
    {
      name: 'total',
      label: 'Total Payments',
      type: 'int'
    },
    {
      name: 'firstPayment',
      label: 'First Success Payment',
      type: 'date'
    },
    {
      name: 'lastPayment',
      label: 'Last Success Payment',
      type: 'date'
    }
  ]

  const getHistoricalPaymentsData = useCallback(async (masterId) => {
    setIsLoading(true)
    dispatch(
      getChildSuppliersWithMasterId(masterId, null, null, false, true)
    ).then(res => {
      if (res && res?.length > 0) {
        const historicalPayments = res?.filter(payment => payment?.historicalPayment)
        const hisPayments = historicalPayments?.flatMap(item => item?.historicalPayment)
        setHistoricalPayments(hisPayments)
      } else {
        setHistoricalPayments([])
      }
      setIsLoading(false)
    }).catch(() => {
      toast.show({
        title: 'Warning',
        description: 'Failed to get historical payments data!'
      })
      setIsLoading(false)
      setHistoricalPayments([])
    })
  }, [])

  useEffect(() => {
    if (masterId) {
      getHistoricalPaymentsData(masterId)
    } else {
      if (masterSupplierDetails?.childVendors && masterSupplierDetails?.childVendors?.length > 0) {
        const historicalPayments = masterSupplierDetails?.childVendors?.filter(payment => payment?.historicalPayment)
        const hisPayments = historicalPayments?.flatMap(item => item?.historicalPayment)
        setHistoricalPayments(hisPayments)
      } else {
        setHistoricalPayments([])
      }
    }
  }, [masterSupplierDetails, masterId])

  const headerElements = columns.map((col, index) => {
    if (index === 0) {
      return <Column
        key={col.name}
        flexGrow={1}
      >
        <HeaderCell title={col.label}>{col.label}</HeaderCell>
        <Cell dataKey={col.name} >
          {rowData => {
            return (
              <Link to={`/suppliers/relatedsupplier/${rowData?.supplierId}`} target='_blank'>
                {rowData?.[col.name]}
              </Link>
            )
          }}
        </Cell>
      </Column>
    }

    return <Column
      key={col.name}
      flexGrow={1}
    >
      <HeaderCell title={col.label}>{col.label}</HeaderCell>
      <TableCell dataKey={col.name} type={col?.type || 'string'} />
    </Column>
  })

  const handleChangeLimit = dataKey => {
    setPage(1);
    setLimit(dataKey);
  }

  const paginatedData = historicalPayments?.sort((a, b) => {
  }).slice(limit * (page - 1), limit * page)

  return (
    <div className="card supply-player-detail">
      <div className="card-header flex-column flex-sm-row align-items-start align-items-sm-center h-auto gap-2">
        <h3 className='fw-bold'>Historical Payments</h3>
      </div>
      <div className={`card-content${isLoading ? ' position-relative loading' : ''}`}>
        {isLoading && <LoaderComponent />}
        <Table
          virtualized
          height={300}
          affixHeader={true}
          data={paginatedData}
        >
          {headerElements}
        </Table>
        <div className="payer-details-table-pagination">
          <Pagination
            prev
            next
            first
            last
            maxButtons={5}
            activePage={page}
            showInfo
            layout={['limit', '|', 'pager']}
            displayLength={limit}
            total={historicalPayments?.length || 0}
            lengthMenu={[
              {
                label: '10',
                value: 10,
              },
              {
                label: '20',
                value: 20,
              },
              {
                label: '30',
                value: 30,
              },
              {
                label: '50',
                value: 50,
              },
              {
                label: '100',
                value: 100,
              },
            ]}
            onChangePage={(event) => { setPage(event) }}
            onChangeLength={handleChangeLimit}
          />
        </div>
      </div>
    </div>
  )
}

export default SupplierHistoricalPayments